<template>
  <el-drawer :visible.sync="drawer" :with-header="false" size="860px">
    <div class="join-inquiry-list-drawer">
      <div>
        <i class="el-icon-close" style="font-size:22px" @click="close"></i>
      </div>
      <div class="join-inquier-list-product">
        <div class="item-box-add">
          <el-row>
            <el-col :span="18">
              <span class="title-font-style">采购退货明细</span>
            </el-col>
            <el-col :span="6" style="text-align:right">
              <el-button @click='exportOut'>导出</el-button>
            </el-col>
          </el-row>
          <el-form>
            <div class="add-content details-line-height" style="padding: 0 0 10px 30px;">
              <el-row>
                <el-col :span="12">
                  <el-form-item label="采购合同：" label-width="70px" >
                    <div>{{ queryParams.pcbNumber || '--'}}</div>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="供应商合同编号：" label-width="115px">
                    <div>
                      {{
                      queryParams.supplierContractNumber || '--'
                      }}
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="供应商名称：" label-width="85px">
                    <span>{{queryParams.suName || '--' }}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="日期：" label-width="45px">
                    {{ queryParams.createDate || '--' }}
                  </el-form-item>
                </el-col>
              </el-row>

            </div>
          </el-form>
          <div :style="{height:tableHeight+'px'}">
            <el-table
              :summary-method="getSummaries"
              show-summary
              border
              ref="tableRef"
              tooltip-effect="dark"
              :data="list"
              :max-height="tableHeight"
              :header-cell-style="tableHeader"
              v-loading="loadingTable"
              element-loading-text="拼命加载中请稍后..."
              element-loading-spinner="el-icon-loading"
             >
              <el-table-column label='品牌'  show-overflow-tooltip>
                <template slot-scope="scope">
                  <div class='line-limit-length'>{{scope.row.brandName|| '--'}}</div>
                </template>
              </el-table-column>
              <el-table-column label="系列"  show-overflow-tooltip>
                <template slot-scope="scope">
                  <div class='line-limit-length'>{{scope.row.seriesName || '--'}}</div>
                </template>
              </el-table-column>
               <el-table-column label="产品名称"  show-overflow-tooltip>
                <template slot-scope="scope">
                  <div class='line-limit-length'>{{scope.row.proName || '--'}}</div>
                </template>
              </el-table-column>
               <el-table-column label="型号"  show-overflow-tooltip>
                <template slot-scope="scope">
                  <div class='line-limit-length'>{{scope.row.proModel || '--'}}</div>
                </template>
              </el-table-column>
              <el-table-column label="订货号"  show-overflow-tooltip>
                <template slot-scope="scope">
                  <div class='line-limit-length'>{{scope.row.proOrdernum || '--'}}</div>
                </template>
              </el-table-column>
              <el-table-column label="单位">
                <template slot-scope="scope">
                  <div>{{scope.row.proUnit || '--'}}</div>
                </template>
              </el-table-column>
              <el-table-column label="退货数量">
                <template slot-scope="scope">
                  <div>{{String(scope.row.receiptCount) || '--'}}</div>
                </template>
              </el-table-column>
                  <el-table-column label="实际采购单价" width="120" >
              <template slot-scope="scope">
                <div>{{scope.row.price|priceFilterNum}}</div>
              </template>
            </el-table-column>
                <el-table-column label="实际采购总价" width="120">
              <template slot-scope="scope">
                <div>{{scope.row.allPrice|priceFilterNum}}</div>
              </template>
            </el-table-column>
            </el-table>
          </div>
          <div class="pagination">
            <pagination
              :total="total"
              :currentPage="currentPage"
              :pageSize="pageSize"
              @handleCurrentChange="handleCurrentChange"
              @handleSizeChange="handleSizeChange"
            ></pagination>
          </div>
        </div>
      </div>
    </div>
  </el-drawer>
</template>
<script>
import pagination from '@/components/pagination'
import { queryReportReceiptDetails, reportReceiptDetails } from '@/api/data/data'
import { downLoadFileBlob, isSuccess } from '@/util/tool'

export default {
  components: {
    pagination
  },
  data() {
    return {
      currentPage: 1,
      pageSize: 30,
      total: 0,
      drawer: false,
      list: [],
      queryParams: '',
      tableHeight: window.innerHeight - 380,
      loadingTable: false,
      time: {}
    }
  },
  methods: {
    getSummaries(param) {
      // 合计
      const sums = []
      param.columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '总计'
        } else if (index === 6) {
          sums[index] = param.data.reduce((tot, prov) => {
            return tot + +prov.receiptCount
          }, 0)
        } else if (index === 8) {
          const total = param.data.reduce((tot, prov) => {
            return tot + +prov.allPrice
          }, 0)
          sums[index] = total.toFixed(2)
        } else {
          sums[index] = ''
        }
      })
      return sums
    },
    // 报缺侧边栏初始化
    onInitialize(row) {
      this.queryParams = row
      this.drawer = true
      this.getList()
    },
    getList() {
      this.loadingTable = true
      const params = {
        criteriaVoList: [],
        queryPageName: ''
      }
      queryReportReceiptDetails(this.currentPage, this.pageSize, this.queryParams.pcrId, params).then(
        res => {
          if (isSuccess(res)) {
            this.list = res.data.obj.receiptDetailsVoPage.records
            this.loadingTable = false
            this.total = res.data.obj.receiptDetailsVoPage.total
          }
        }
      )
    },
    exportOut() {
      reportReceiptDetails(this.queryParams.pcrId)
        .then(res => {
          downLoadFileBlob(this, res)
        })
        .catch(err => {
          console.log(err)
        })
    },

    // 设置头部背景色
    tableHeader({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    },
    // 关闭
    close() {
      this.drawer = false
    },
    handleSizeChange(val) {
      this.currentPage = 1
      this.pageSize = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getList()
    }
  }
}
</script>
<style  lang="scss" scoped>
.boxHeight {
  height: 200px;
}
h5,
h4 {
  text-align: center !important;
}
h5 {
  margin: 0px !important;
  font-size: 14px;
}
.join-inquiry-list-drawer {
  padding: 20px;
  font-size: 14px !important;
  .join-inquier-list-crumbs {
    padding-left: 20px;
    font-size: 14px;
    span:first-child {
      padding-right: 10px;
    }
  }
  .join-inquier-list-product {
    padding: 30px 0 0 0px;
    .item-box-add {
      margin: 0 0 30px 0;
      .title-font-style {
        margin-bottom: 20px;
        font-weight: bold;
        font-size: 16px;
      }
      .serial_list {
        border: 1px solid #ebeef6;
        height: 500px;
        margin-top: 15px;
        width: 100%;
        display: flex;
        align-content: flex-start;
        justify-content: flex-start;
        flex-wrap: wrap;
        .serial_list_item {
          border-right: 1px solid #ebeef6;
          border-bottom: 1px solid #ebeef6;
          width: 16.5%;
          height: 40px;
          line-height: 40px;
          text-align: center;
          &:nth-child(6n) {
            border-right: none;
          }
        }
      }
    }
  }
  .dialog-footer {
    width: 180px;
    margin: 30px auto;
    float: right;
  }
}
</style>
